module.exports = __webpack_public_path__ + "./fonts/BebasNeue-Bold.ttf";